import { inject } from 'vue'
import type { ToastGlobal } from '../components/lib/toast'

export const useToast = () => {
  const $toast = inject<ToastGlobal>('$toast')
  if (!$toast) {
    throw new Error('Toast not found')
  }
  return { $toast }
}
